import EventBus from '@/helpers/event-bus';
import MaterialsService from '@/services/Materials/MaterialsService';

const state = {
    materials: [],
    current: null,
    parent: null
};

const actions = {
    materials({ commit }) {
        return MaterialsService.getMaterials().then(result => {
            commit('materials', result.data);
        });
    },
    current({ commit }, data) {
        commit('current', data);
    },
    parent({ commit }, data) {
        commit('parent', data);
    },
    setMaterialsSlVueTree({ commit }, data) {
        const materials = objectToArray(deepCopy(data));

        function traverseTree(elements) {
            elements.forEach(e => {
                delete e.data;
                delete e.title;
                delete e.isLeaf;
                if (typeof e.children !== 'undefined' && e.children.length > 0) {
                    traverseTree(e.children);
                }
            });
        }

        traverseTree(materials);
        commit('materials', materials);
    },
    save() {
        return MaterialsService.save(state.current).then(() => {});
    },
    async remove({ dispatch }, id) {
        try {
            const { data } = await MaterialsService.remove(id);
            if (data && data.status === 1) {
                EventBus.$emit('snotifySuccess', 'Remove tree success.');
                dispatch('materials');
            }
        } catch (error) {
            EventBus.$emit('snotifyError', error.response.data.errors[0].msg);
        }
    },
    async saveOrder(_, credentials) {
        try {
            const { data } = await MaterialsService.saveOrder(credentials);
            if (data && data.status === 1) {
                EventBus.$emit('snotifySuccess', 'Updating tree success.');
            }
        } catch (error) {
            EventBus.$emit('snotifyError', 'Updating tree error.');
        }
    },
    changeVisibility(_, data) {
        return MaterialsService.changeVisibility(data).then(() => {});
    }
};

const mutations = {
    materials(state, data) {
        state.materials = data;
    },
    current(state, data) {
        state.current = data;
    },
    parent(state, data) {
        state.parent = data;
    }
};

const getters = {
    materials(state) {
        return state.materials;
    },
    materialsSlVueTree(state) {
        const materials = objectToArray(deepCopy(state.materials));
        function traverseTree(elements) {
            elements.forEach(e => {
                e.title = e.name;
                e.data = {
                    id: e.id,
                    name: e.name,
                    parent_id: e.parent_id,
                    visible: typeof e.visible !== 'undefined' ? e.visible : true,
                    can_be_changed: typeof e.can_be_changed !== 'undefined' ? e.can_be_changed : true
                };

                if (typeof e.children !== 'undefined' && e.children.length > 0) {
                    traverseTree(e.children);
                }
                else {
                    e.isLeaf = true;
                }
            });
        }
        traverseTree(materials);
        return materials;
    },
    flatMaterials(state) {
        const materials = objectToArray(deepCopy(state.materials));

        const flat = (array) => {
            let result = [];
            array.forEach((a) => {
                result.push(a);
                if (Array.isArray(a.children)) {
                    const children = a.children;
                    delete a.children;
                    result = result.concat(flat(children));
                }
            });
            return result;
        };
        return flat(materials);
    },
    current(state) {
        return state.current;
    },
    parent(state) {
        return state.parent;
    }
};

export default {
    state,
    mutations,
    actions,
    getters,
    namespaced: true
};
